import styled from 'styled-components';
import {
  fontVariables,
  boxShadowsVariables,
  colorsVariables,
  gutterVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { minWidth } from 'helpers/buildMediaQueries';

export const ResultItem = styled.a`
  background: ${colorsVariables.WHITE};
  border-radius: 8px;
  box-shadow: ${boxShadowsVariables.shopCard};
  border-top: 7px solid ${colorsVariables.PINEAPPLE_500};
  margin-bottom: ${gutterVariables.GUTTER_DOUBLE};
  cursor: pointer;
  text-decoration: none;

  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto auto auto;
  grid-template-areas:
    'header'
    'shopStatus'
    'description'
    'links';

  &:hover {
    box-shadow: ${boxShadowsVariables.shopCardHover};
  }
`;

export const Description = styled.div`
  grid-area: description;
  margin-bottom: ${gutterVariables.GUTTER};
  font-size: ${fontVariables.SIZE_TEXT_S};
  line-height: 1.5;
  padding: 0 ${gutterVariables.GUTTER};
  color: ${colorsVariables.GRAY_700};

  ${minWidth(
    'xl',
    `padding: 0 ${gutterVariables.GUTTER_PLUS_HALF}; margin-bottom: ${gutterVariables.GUTTER_PLUS_HALF};`
  )};
`;

export const DescriptionText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const AiDisclaimer = styled.div`
  color: #667085;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 8px;
`;
